import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { sseClient } from '#pplx_generated/typespec/rest/sse/client.js';
export const terminateEntry = async ({ entryUUID, reason, contextUUID, modelPreference, terminateRequestedAtMs, }) => {
    try {
        const { error } = await sseClient.POST('/rest/sse/perplexity_terminate', reason, {
            headers: {
                'content-type': 'application/json',
            },
            body: {
                entry_uuid: entryUUID,
                context_uuid: contextUUID,
                model_preference: modelPreference,
                terminate_requested_at_ms: terminateRequestedAtMs,
            },
            timeoutMs: getQueryTimeoutMs({ productionMs: 5000 }),
            numRetries: 1,
        });
        if (error) {
            return false;
        }
        return true;
    }
    catch (err) {
        logger.error('Failed to terminate entry', err);
        return false;
    }
};
//# sourceMappingURL=terminateEntry.js.map